import { updateObject } from "utils/helpers/updateObject";
import {
  actionTypes,
  CreateDcddMembershipFailureAction,
  CreateDcddMembershipRequestAction,
  CreateDcddMembershipSuccessAction,
  DcddMembershipActions,
  FetchDcddMembershipFailureAction,
  FetchDcddMembershipRequestAction,
  FetchDcddMembershipSuccessAction,
  stateStatusType,
  UpdateDcddMembershipFailAction,
  UpdateDcddMembershipRequestAction,
  UpdateDcddMembershipStatusFailAction,
  UpdateDcddMembershipStatusRequestAction,
  UpdateDcddMembershipStatusSuccessAction,
  UpdateDcddMembershipSuccessAction,
} from "./actionType";
import { initialState, DcddMembershipState } from "./state";
import { DcddMembershipStatus } from "props/enum";

//FetchVideoEpisodeRequest
const FetchDcddMembershipRequest = (
  state: DcddMembershipState,
  action: FetchDcddMembershipRequestAction
) => {
  return updateObject(state, {
    dcddMembershipState: {
      ...state.dcddMembershipState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const FetchDcddMembershipSuccess = (
  state: DcddMembershipState,
  action: FetchDcddMembershipSuccessAction
) => {
  return updateObject(state, {
    dcddMembershipState: {
      ...state.dcddMembershipState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      membership: action.payload,
    },
  });
};

const FetchDcddMembershipFail = (
  state: DcddMembershipState,
  action: FetchDcddMembershipFailureAction
) => {
  return updateObject(state, {
    dcddMembershipState: {
      ...state.dcddMembershipState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      membership: null,
    },
  });
};
//create membership
const createDcddMembershipRequest = (
  state: DcddMembershipState,
  action: CreateDcddMembershipRequestAction
) => {
  return updateObject(state, {
    dcddMembershipState: {
      ...state.dcddMembershipState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};
const createDcddMembershipSuccess = (
  state: DcddMembershipState,
  action: CreateDcddMembershipSuccessAction
) => {
  const existingMemebershipPlan = state.dcddMembershipState.membership ?? [];
  return updateObject(state, {
    genericDcddMembershipState: {
      ...state.genericDcddMembershipState,
      membership: {
        ...action.payload,
      },
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    dcddMembershipState: {
      ...state.dcddMembershipState,
      membership: [...existingMemebershipPlan, action.payload],
    },
  });
};

const createDcddMembershipFail = (
  state: DcddMembershipState,
  action: CreateDcddMembershipFailureAction
) => {
  return updateObject(state, {
    genericDcddMembershipState: {
      ...state.genericDcddMembershipState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    dcddMembershipState: {
      ...state.dcddMembershipState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

//Update membership
const updateDcddMembershipRequest = (
  state: DcddMembershipState,
  action: UpdateDcddMembershipRequestAction
) => {
  return updateObject(state, {
    dcddMembershipState: {
      ...state.dcddMembershipState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};
const updateMembershipSuccess = (
  state: DcddMembershipState,
  action: UpdateDcddMembershipSuccessAction
) => {
  const newDcddMembershipPlan = state.dcddMembershipState.membership?.map(
    (item) => (item.id === action.payload.id ? action.payload : item)
  ) ?? [action.payload];
  return updateObject(state, {
    genericDcddMembershipState: {
      ...state.genericDcddMembershipState,
      isLoading: false,
      error: null,
      state: stateStatusType.SUCCESS,
    },
    dcddMembershipState: {
      ...state.dcddMembershipState,
      state: stateStatusType.SUCCESS,
      membership: [...newDcddMembershipPlan],
    },
  });
};
const updateMembershipFail = (
  state: DcddMembershipState,
  action: UpdateDcddMembershipFailAction
) => {
  return updateObject(state, {
    genericDcddMembershipState: {
      ...state.genericDcddMembershipState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    dcddMembershipState: {
      ...state.dcddMembershipState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};
//Update membership status
const updateDcddMembershipStatusRequest = (
  state: DcddMembershipState,
  action: UpdateDcddMembershipStatusRequestAction
) => {
  return updateObject(state, {
    dcddMembershipState: {
      ...state.dcddMembershipState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};
const updateDcddMembershipStatusSuccess = (
  state: DcddMembershipState,
  action: UpdateDcddMembershipStatusSuccessAction
) => {
  const updatedMembershipId = action.payload.id;
  const newMembershipList = state.dcddMembershipState.membership?.map((item) => {
    if (item.id === updatedMembershipId) {
      return action.payload;
    } else {
      if (action.payload.status === DcddMembershipStatus.Active && item.status === DcddMembershipStatus.Active) {
        return {
          ...item,
          status: DcddMembershipStatus.Inactive, 
        };
      }
      return item;
    }
  }) ?? [action.payload];

  return updateObject(state, {
    genericDcddMembershipState: {
      ...state.genericDcddMembershipState,
      isLoading: false,
      error: null,
      state: stateStatusType.SUCCESS,
    },
    dcddMembershipState: {
      ...state.dcddMembershipState,
      state: stateStatusType.SUCCESS,
      membership: newMembershipList,
    },
  });
};

const updateDcddMembershipStatusFail = (
  state: DcddMembershipState,
  action: UpdateDcddMembershipStatusFailAction
) => {
  return updateObject(state, {
    genericDcddMembershipState: {
      ...state.genericDcddMembershipState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    dcddMembershipState: {
      ...state.dcddMembershipState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};
const DcddMembershipReducer = (
  state = initialState,
  action: DcddMembershipActions
) => {
  switch (action.type) {
    case actionTypes.FETCH_DCDD_MEMBERSHIP_REQUEST:
      return FetchDcddMembershipRequest(state, action);
    case actionTypes.FETCH_DCDD_MEMBERSHIP_SUCCESS:
      return FetchDcddMembershipSuccess(state, action);
    case actionTypes.FETCH_DCDD_MEMBERSHIP_FAIL:
      return FetchDcddMembershipFail(state, action);
    case actionTypes.CREATE_DCDD_MEMBERSHIP_PLAN_REQUEST:
      return createDcddMembershipRequest(state, action);
    case actionTypes.CREATE_DCDD_MEMBERSHIP_PLAN_SUCCESS:
      return createDcddMembershipSuccess(state, action);
    case actionTypes.CREATE_DCDD_MEMBERSHIP_PLAN_FAIL:
      return createDcddMembershipFail(state, action);
    case actionTypes.UPDATE_DCDD_MEMBERSHIP_PLAN_REQUEST:
      return updateDcddMembershipRequest(state, action);
    case actionTypes.UPDATE_DCDD_MEMBERSHIP_PLAN_SUCCESS:
      return updateMembershipSuccess(state, action);
    case actionTypes.UPDATE_DCDD_MEMBERSHIP_PLAN_FAIL:
      return updateMembershipFail(state, action);
    case actionTypes.UPDATE_DCDD_MEMBERSHIP_PLAN_STATUS_REQUEST:
      return updateDcddMembershipStatusRequest(state, action);
    case actionTypes.UPDATE_DCDD_MEMBERSHIP_PLAN_STATUS_SUCCESS:
      return updateDcddMembershipStatusSuccess(state, action);
    case actionTypes.UPDATE_DCDD_MEMBERSHIP_PLAN_STATUS_FAIL:
      return updateDcddMembershipStatusFail(state, action);
    default:
      return state;
  }
};

export default DcddMembershipReducer;
